import React from 'react';
import { concat } from 'lodash';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import ProcessData from './ProcessData';

const SessionTableHeader = props => {
  const isBlueBox = dataFile => {
    const blueBoxIds = [10, 11, 25, 27, 30];
    return blueBoxIds.includes(dataFile.id); // temporaire
  };

  const topHeaderFileColumns = props.fileTypes.map((file, i) => {
    return (
      <Table.HeaderCell key={`file_top_${i}`} colSpan={file.abstract_types.length + (isBlueBox(file) ? 2 : 1)}>
        {file.name}
      </Table.HeaderCell>
    );
  });

  const bottomHeaderFileColumns = props.fileTypes.map((dataFile, i) => {
    return concat(
      <Table.HeaderCell key={`file_top_upload_${i}`}>Upload</Table.HeaderCell>,
      isBlueBox(dataFile) ?
        <Table.HeaderCell key={`file_top_download_${i}`}>Download</Table.HeaderCell> : null,
      dataFile.abstract_types.map((dataAcquisition, m_i) => {
        return (
          <Table.HeaderCell key={`file_${dataFile.id}_metric_${dataAcquisition.id}`}>
            {dataAcquisition.name.split(" ")[0]}
          </Table.HeaderCell>
        );
      })
    );
  });

  const bottomHeaderProcessDataColumns = props.fileTypes.map((dataFile, i) => {
    return concat(
      <Table.HeaderCell key="empty_0" />,
      dataFile.abstract_types.map((dataAcquisition, m_i) => {
        return (
          <Table.HeaderCell
            className="prosessData-cell"
            key={`fileData_${dataFile.id}_metric_${dataAcquisition.id}`}
          >
            <ProcessData
              fileDataId={dataFile.id}
              metricName={dataAcquisition.name}
              dataQty="column"
            />
          </Table.HeaderCell>
        );
      })
    );
  });

  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Activate</Table.HeaderCell>
        <Table.HeaderCell>Session</Table.HeaderCell>
        <Table.HeaderCell>Participants</Table.HeaderCell>
        <Table.HeaderCell>Condition</Table.HeaderCell>
        {topHeaderFileColumns}
        <Table.HeaderCell>Transformation Status</Table.HeaderCell>
        <Table.HeaderCell>Messages</Table.HeaderCell>
      </Table.Row>

      <Table.Row>
        <Table.HeaderCell colSpan={4} />
        {bottomHeaderFileColumns}
        <Table.HeaderCell />
        <Table.HeaderCell />
      </Table.Row>

      <Table.Row className="processData_row" key="rowProcessAllData" style={{ display: 'none' }}>
        <Table.HeaderCell colSpan={4} />
        {bottomHeaderProcessDataColumns}
        <Table.HeaderCell key="empty" />
      </Table.Row>
    </Table.Header>
  );
};

SessionTableHeader.propTypes = {
  fileTypes: PropTypes.array
};

export default SessionTableHeader;



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/SessionTableHeader.js